import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconClock } from '#src/atoms/icons/system/iconClock.ts';
import { LabelS } from '#src/atoms/typography/index.tsx';
import { Chip } from '#src/atoms/ui/Chip/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { TimeLeft } from '#src/contexts/ticker/TimeLeft/index.tsx';

const Layout = styled(LabelS).attrs({ bold: true })``;

export const ActivePromotionalEventTimeLeft = () => {
  const { currentUser } = useCurrentUserContext();

  if (
    !currentUser?.completablePromotionalEvent?.promotionalEventCompletion
      ?.expiresAt
  )
    return null;
  return (
    <Chip size="M" color="yellow">
      <FontAwesomeIcon size="xs" icon={iconClock} />
      <TimeLeft
        time={
          currentUser.completablePromotionalEvent.promotionalEventCompletion
            .expiresAt
        }
        Layout={Layout}
        withExplicitTime
        hideTooltip
      />
    </Chip>
  );
};
